(function bootGrovaCartDrawer() {
  document.documentElement.dataset.grovaCartScriptLoaded = 'true';
  const root = document.querySelector('[data-grova-cart]');
  if (!root) {
    // Deferred loading normally finds the shell; support editor insertion without polling.
    document.addEventListener('shopify:section:load', bootGrovaCartDrawer, { once: true });
    return;
  }
  if (root.dataset.grovaCartInitialized === 'true') return;
  root.dataset.grovaCartInitialized = 'true';
  try {
  const body = root.querySelector('[data-grova-cart-body]');
  const footer = root.querySelector('[data-grova-cart-footer]');
  const note = root.querySelector('[data-grova-cart-subscription-note]');
  const shippingText = root.querySelector('[data-grova-cart-shipping-text]');
  const shippingProgress = root.querySelector('[data-grova-cart-shipping-progress]');
  const totalEl = root.querySelector('[data-grova-cart-total]');
  const originalTotalEl = root.querySelector('[data-grova-cart-original-total]');
  const checkoutTotalEl = root.querySelector('[data-grova-cart-checkout-total]');
  const discountRow = root.querySelector('[data-grova-cart-discount-row]');
  const discountLabel = root.querySelector('[data-grova-cart-discount-label]');
  const discountCodesEl = root.querySelector('[data-grova-cart-discount-codes]');
  const initialJson = root.querySelector('[data-grova-cart-json]');
  const removeIcon = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="m2 2 12 12M14 2 2 14" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>';
  const addIcon = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8 2v12M2 8h12" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>';
  const binIcon = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M3 5h14M7 2.5h6M5 5v12.5h10V5" fill="none" stroke="currentColor" stroke-width="1" stroke-linejoin="round"/></svg>';
  const emptyUrl = root.dataset.emptyUrl || '/collections/all';
  const currentCurrency = root.dataset.currency || window.Shopify?.currency?.active || document.documentElement.dataset.currency || 'EUR';
  const giftCardImages = {
    '1000': root.dataset.giftCardImage10 || '',
    '2000': root.dataset.giftCardImage20 || '',
  };
  const logoUrl = 'https://cdn.shopify.com/s/files/1/0889/9808/4942/files/grova_1.png?v=1747000939';
  const bundleProducts = new Map([
    ['10890084286798', { supply: '6 Month Supply', giftCardCents: 1000 }],
    ['10890082877774', { supply: '12 Month Supply', giftCardCents: 2000 }],
  ]);
  const offers = window.GrovaOffers;
  const offerConfig = offers.read(root);
  const editableSubscriptionOptions = offerConfig.primary;
  const goldOption = editableSubscriptionOptions.find((option) => option.key === '3');
  const monthlyOption = editableSubscriptionOptions.find((option) => option.key === '1');
  const subscriptionGifts = offerConfig.gifts;
  const subscriptionGiftVariantIds = new Set(offerConfig.canSyncGifts
    ? [...Object.values(subscriptionGifts).map((gift) => String(gift.variantId)), ...offerConfig.retiredGiftIds]
    : []);
  const removedSubscriptionGiftsAttribute = '_grova_removed_subscription_gifts';
  const removedSubscriptionGiftsVersionAttribute = '_grova_removed_subscription_gifts_version';
  const removedSubscriptionGiftsVersion = '2';
  let cart = parseInitialCart();
  let refreshPromise = null;
  let giftSyncPromise = null;
  let updatingLine = null;
  let removingItemKey = null;
  let closeTimer = null;
  let confettiTimer = null;
  let touchStartY = 0;
  let pageScrollLock = null;
  let lastItemsMarkup = null;
  const productCache = new Map();
  const moneyFormatters = new Map();
  const hydrationPromises = new WeakMap();

  function parseInitialCart() {
    try {
      return JSON.parse(initialJson?.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function currencyCode() {
    return currentCurrency;
  }

  function formatMoney(cents) {
    const value = (Number(cents) || 0) / 100;
    const fractionDigits = value % 1 === 0 ? 0 : 2;
    const key = `${currencyCode()}-${fractionDigits}`;
    if (!moneyFormatters.has(key)) {
      moneyFormatters.set(
        key,
        new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currencyCode(),
          minimumFractionDigits: fractionDigits,
          maximumFractionDigits: 2,
        })
      );
    }
    return moneyFormatters.get(key).format(value);
  }

  function formatCurrencyValue(value) {
    const amount = Number(value) || 0;
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode(),
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function isOptiMonkEvent(event) {
    return event.composedPath().some((node) => {
      if (!(node instanceof Element)) return false;
      const identity = `${node.id} ${node.className} ${node.getAttribute('src') || ''}`.toLowerCase();
      return identity.includes('optimonk') || identity.includes('om-holder-campaign-');
    });
  }

  function logoMarkup() {
    return `
      <img
        class="grova-cart__mark"
        src="${logoUrl}"
        alt="Grova"
        width="609"
        height="223"
        loading="eager"
        decoding="async"
      >
    `;
  }

  function hasSubscriptionItems() {
    return Array.isArray(cart.items) && cart.items.some((item) => item.selling_plan_allocation);
  }

  function hasFreeShippingItems() {
    return hasSubscriptionItems() || (
      Array.isArray(cart.items) && cart.items.some((item) => bundleProducts.has(String(item.product_id)))
    );
  }

  function itemOriginalLinePrice(item) {
    const option = offers.forItem(offerConfig, item);
    if (option) return Math.max(option.compareAt, item.original_price || 0) * item.quantity;

    const compareAt = item.variant?.compare_at_price || item.compare_at_price || item._variant_compare_at_price;
    if (compareAt && compareAt > item.original_price) {
      return compareAt * item.quantity;
    }

    return item.original_line_price || item.original_price * item.quantity;
  }

  function itemFinalLinePrice(item) {
    return item.final_line_price ?? item.line_price ?? item.price * item.quantity;
  }

  function itemCodeDiscountTotal(item) {
    return (item.line_level_discount_allocations || []).reduce((total, allocation) => {
      return allocation.discount_application?.type === 'discount_code' ? total + (Number(allocation.amount) || 0) : total;
    }, 0);
  }

  function itemDisplayedLinePrice(item) {
    return itemFinalLinePrice(item) + itemCodeDiscountTotal(item);
  }

  function appliedCodeDiscounts(cartData) {
    const applications = [
      ...(cartData.cart_level_discount_applications || []),
      ...(cartData.items || []).flatMap((item) =>
        (item.line_level_discount_allocations || []).map((allocation) => allocation.discount_application).filter(Boolean)
      ),
    ];

    return applications
      .filter((application) => application.type === 'discount_code')
      .filter(
        (application, index, entries) =>
          entries.findIndex((entry) => (entry.title || entry.code) === (application.title || application.code)) === index
      );
  }

  function discountValueText(application) {
    if (application.value_type === 'percentage') return `${Math.round(Number(application.value) || 0)}% Off`;
    if (application.value_type === 'fixed_amount') return `${formatCurrencyValue(application.value)} Off`;
    return '';
  }

  function renderDiscountCodes() {
    if (!discountRow || !discountCodesEl || !discountLabel) return;

    const discounts = appliedCodeDiscounts(cart);
    const values = [...new Set(discounts.map(discountValueText).filter(Boolean))];
    discountRow.hidden = !discounts.length;
    discountLabel.textContent = values.length ? `Discount (${values.join(', ')})` : 'Discount';
    discountCodesEl.innerHTML = discounts
      .map(
        (discount) => `
          <span class="grova-cart__discount-pill">
            <span>${escapeHtml(discount.title || discount.code)}</span>
            <button
              type="button"
              aria-label="Remove discount code ${escapeHtml(discount.title || discount.code)}"
              data-grova-cart-remove-discount="${escapeHtml(discount.title || discount.code)}"
            >&times;</button>
          </span>
        `
      )
      .join('');
  }

  function variantText(item) {
    const bundle = bundleProducts.get(String(item.product_id));
    if (bundle) return bundle.supply;

    if (item.variant_title && item.variant_title !== 'Default Title') return item.variant_title;
    if (Array.isArray(item.options_with_values) && item.options_with_values.length) {
      return item.options_with_values.map((option) => option.value).join(', ');
    }
    return '';
  }

  function sellingPlanText(item) {
    return item.selling_plan_allocation?.selling_plan?.name || '';
  }

  function deliveryText(item) {
    return sellingPlanText(item).replace(/^Deliver every/i, 'Delivered every') || 'Delivered once';
  }

  function itemTitle(item) {
    const bundleTitle = 'Daily Wellness Mushroom Gummies';
    return bundleProducts.has(String(item.product_id)) ? bundleTitle : item.product_title;
  }

  function bundleGiftMarkup(item) {
    const bundle = bundleProducts.get(String(item.product_id));
    if (!bundle) return '';

    const giftCardValue = formatMoney(bundle.giftCardCents);
    const giftCardImage = giftCardImages[String(bundle.giftCardCents)];
    const image = giftCardImage
      ? `<img src="${escapeHtml(giftCardImage)}" alt="${escapeHtml(giftCardValue)} gift card" loading="lazy">`
      : `<span class="grova-cart__bundle-gift-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M20 12v9H4v-9m-2-5h20v5H2V7Zm10 14V7m0 0H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7Zm0 0h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>
        </span>`;

    return `
      <div class="grova-cart__bundle-gift">
        ${image}
        <span><strong>Free ${escapeHtml(giftCardValue)} Gift Card</strong><small>Included with your bundle</small></span>
      </div>
    `;
  }

  function updateShippingProgress(count) {
    const hasFreeShipping = hasFreeShippingItems();

    note.hidden = !count;
    if (!count) return;

    shippingText.textContent = hasFreeShipping
      ? 'You have unlocked free shipping!'
      : 'Upgrade to subscription to unlock free shipping.';
    shippingProgress.style.width = hasFreeShipping ? '100%' : '42%';
    note.classList.toggle('is-unlocked', hasFreeShipping);
  }

  function productHandleForItem(item) {
    if (item.handle) return item.handle;
    const url = item.url || item.product_url || '';
    return url.split('/products/')[1]?.split(/[/?#]/)[0] || '';
  }

  async function productDataForHandle(handle) {
    if (!handle) return null;
    if (productCache.has(handle)) return productCache.get(handle);

    const productPromise = fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}.js`, {
      credentials: 'same-origin',
      cache: 'force-cache',
    })
      .then((response) => (response.ok ? response.json() : null))
      .catch(() => null);

    productCache.set(handle, productPromise);
    return productPromise;
  }

  function hydrateVariantCompareAtPrices(cartData) {
    if (hydrationPromises.has(cartData)) return hydrationPromises.get(cartData);

    const hydrationPromise = (async () => {
      const items = cartData.items || [];
      let changed = false;
      await Promise.all(
        items.map(async (item) => {
          if (item._variant_compare_at_price || item.variant?.compare_at_price || item.compare_at_price) return;

          if (offers.forItem(offerConfig, item)) return;
          const productData = await productDataForHandle(productHandleForItem(item));
          const variant = productData?.variants?.find((entry) => Number(entry.id) === Number(item.variant_id));
          if (variant?.compare_at_price) {
            item._variant_compare_at_price = Number(variant.compare_at_price);
            changed = true;
          }
        })
      );
      return changed;
    })();

    hydrationPromises.set(cartData, hydrationPromise);
    return hydrationPromise;
  }

  function hydrateAndRender(cartData) {
    hydrateVariantCompareAtPrices(cartData).then((changed) => {
      if (changed && cart === cartData) render();
    });
  }

  function subscriptionOptionForItem(item) {
    return offers.forItem(offerConfig, item);
  }

  function isSubscriptionItem(item) {
    return Boolean(item.selling_plan_allocation);
  }

  function subscriptionControlsMarkup(item, index) {
    const currentOption = subscriptionOptionForItem(item);
    if (!currentOption || (currentOption === goldOption && (cart.items || []).some(isGoldItem))) return '';

    const isUpdating = updatingLine === index + 1;
    const loadingMarkup = isUpdating
      ? '<span class="grova-cart__loading" aria-hidden="true"></span><span class="visually-hidden">Updating cart</span>'
      : '';

    if (!isSubscriptionItem(item)) {
      if (!offers.canBuy(offerConfig, currentOption)) return '';
      const giftBenefit =
        currentOption.key === '3'
          ? `2 FREE gifts worth ${formatMoney(subscriptionGifts.journal.valueCents + subscriptionGifts.canister.valueCents)} included`
          : currentOption.key === '2'
            ? `1 FREE gift worth ${formatMoney(subscriptionGifts.journal.valueCents)} included`
            : '';
      const giftBenefitMarkup = giftBenefit
        ? `
            <li>
              <span aria-hidden="true">
                <svg viewBox="0 0 24 24"><path d="M4 8h16v12H4V8Zm-2-4h20v4H2V4Zm10 16V4m0 4H8.5a2.5 2.5 0 1 1 0-5C11 3 12 8 12 8Zm0 0h3.5a2.5 2.5 0 1 0 0-5C13 3 12 8 12 8Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>
              </span>
              ${giftBenefit}
            </li>
          `
        : '';

      return `
        <div class="grova-cart__subscription grova-cart__subscription--upgrade ${isUpdating ? 'is-loading' : ''}" data-subscription-controls aria-busy="${isUpdating ? 'true' : 'false'}">
          <span class="grova-cart__upgrade-badge">Most Popular</span>
          <h3 class="grova-cart__upgrade-title">Subscribe &amp; Save ${currentOption.discount.replace(' OFF', '')}</h3>
          <ul class="grova-cart__upgrade-benefits">
            <li>
              <span aria-hidden="true">
                <svg viewBox="0 0 24 24"><path d="M4 5h10l6 6-9 9-7-7V5Z" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="9" cy="10" r="1.4" fill="currentColor"/></svg>
              </span>
              Save ${escapeHtml(currentOption.discount.replace(' OFF', ''))} on this ${escapeHtml(currentOption.label.toLowerCase())} supply
            </li>
            ${giftBenefitMarkup}
            <li>
              <span aria-hidden="true">
                <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M9.5 8.5v7M14.5 8.5v7" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
              </span>
              No commitment, modify or cancel any time
            </li>
            <li>
              <span aria-hidden="true">
                <svg viewBox="0 0 24 24"><path d="M3 6h11v10H3V6Zm11 4h3.5l3.5 3.5V16h-7v-6Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="7" cy="18" r="1.8" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="18" cy="18" r="1.8" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>
              </span>
              Free shipping on every order
            </li>
            <li>
              <span aria-hidden="true">
                <svg viewBox="0 0 24 24"><path d="M12 3.5 19 6v5.7c0 4.2-2.8 7.5-7 8.8-4.2-1.3-7-4.6-7-8.8V6l7-2.5Z" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="m8.5 12 2.2 2.2 4.8-5" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>
              </span>
              Love it or get a full refund
            </li>
          </ul>
          <button class="grova-cart__subscribe-button" type="button" data-grova-cart-subscribe="${index + 1}" ${isUpdating ? 'disabled' : ''}>
            ${loadingMarkup}
            <span>Upgrade &amp; Save</span>
          </button>
        </div>
      `;
    }

    return '';
  }

  function isSubscriptionGift(item) {
    return subscriptionGiftVariantIds.has(String(item?.variant_id));
  }

  function isGoldItem(item) {
    return Boolean(goldOption && isSubscriptionItem(item) && subscriptionOptionForItem(item) === goldOption);
  }

  function giftImage(key) {
    const images = { journal: root.dataset.giftJournalImage, canister: root.dataset.giftCanisterImage };
    return images[key] || subscriptionGifts[key]?.image || '';
  }

  function goldUpgradeMarkup(item, index) {
    if ((cart.items || []).some(isGoldItem) ||
        subscriptionOptionForItem(item) !== monthlyOption ||
        !offerConfig.canSyncGifts || !offers.canBuy(offerConfig, goldOption)) return '';
    const oneTime = !isSubscriptionItem(item);
    const quantity = item.quantity;
    const firstPrice = goldOption.subscriptionPrice * quantity;
    const renewalPrice = goldOption.renewalPrice * quantity;
    const extra = firstPrice - itemFinalLinePrice(item);
    const hasDiscounts = appliedCodeDiscounts(cart).length > 0 || (cart.total_discount || 0) > 0;
    const action = hasDiscounts ? 'Upgrade to Gold' : extra > 0
      ? `Upgrade${oneTime ? ' to Gold' : ''} for +${formatMoney(extra)} today`
      : extra < 0 ? `Upgrade & save ${formatMoney(-extra)} today` : 'Upgrade at no extra cost';
    const busy = updatingLine !== null;
    return `
      <section class="grova-cart__gold-upgrade" aria-labelledby="grova-gold-upgrade-${index}" aria-busy="${busy}">
        <p class="grova-cart__gold-eyebrow">Upgrade your order</p>
        <h3 id="grova-gold-upgrade-${index}" data-grova-type="compact-heading">Buy 2 bags. Get the 3rd free.</h3>
        <p class="grova-cart__gold-summary">${quantity * 3} bags · ${formatMoney(firstPrice)} today</p>
        <div class="grova-cart__gold-gifts">
          <span class="grova-cart__gold-gift-images" aria-hidden="true">${goldOption.giftKeys.map((key) => giftImage(key) ? `<img src="${escapeHtml(giftImage(key))}" alt="" width="26" height="34" loading="lazy">` : '').join('')}</span>
          <span>Plus free gifts</span>
        </div>
        <button class="grova-cart__gold-button" type="button" data-grova-cart-plan="3" ${busy ? 'disabled' : ''}>
          ${updatingLine === index + 1 ? '<span class="grova-cart__loading" aria-hidden="true"></span> Updating…' : escapeHtml(action)}
        </button>
        <p class="grova-cart__gold-terms">Then ${formatMoney(renewalPrice)} every 3 months. Skip, pause or cancel anytime.${oneTime ? ` Replaces your ${quantity > 1 ? `${quantity} one-time bags` : 'one-time purchase'}.` : quantity > 1 ? ` Replaces all ${quantity} monthly supplies.` : ''}${hasDiscounts ? ' Prices before additional cart discounts.' : ''}</p>
      </section>
    `;
  }

  function subscriptionGiftsMarkup(item) {
    if (!isSubscriptionItem(item)) return '';
    const option = subscriptionOptionForItem(item);
    const eligibleGiftKeys = offerConfig.canSyncGifts ? option?.giftKeys || [] : [];
    const removedVariantIds = removedSubscriptionGiftVariantIds(cart);
    const giftItems = eligibleGiftKeys
      .map((key) => ({
        key,
        item: (cart.items || []).find(
          (cartItem) => String(cartItem.variant_id) === String(subscriptionGifts[key].variantId)
        ),
      })).filter(({ key, item: giftItem }) => giftItem || removedVariantIds.has(String(subscriptionGifts[key].variantId)));
    if (!giftItems.length) return '';

    return `
      <div class="grova-cart__free-gifts">
        <h3>First Order Free Gifts</h3>
        ${giftItems
          .map(({ key, item: giftItem }) => {
            const gift = subscriptionGifts[key];
            const isRemoved = removedVariantIds.has(String(gift.variantId));
            const giftQuantity = Math.max(1, Number(giftItem?.quantity) || Number(item.quantity) || 1);
            const giftTitle = gift.title;
            return `
              <div class="grova-cart__free-gift ${isRemoved ? 'is-removed' : ''}">
                <img src="${escapeHtml(giftImage(key))}" alt="" loading="lazy">
                <span class="grova-cart__free-gift-title">${giftQuantity > 1 ? `${giftQuantity} × ` : ''}${escapeHtml(giftTitle)}</span>
                <span class="grova-cart__free-gift-price"><strong>${
                  isRemoved ? 'REMOVED' : 'FREE'
                }</strong></span>
                <button
                  class="grova-cart__free-gift-remove"
                  type="button"
                  aria-label="${isRemoved ? 'Add back' : 'Remove'} free ${escapeHtml(gift.title)}"
                  title="${isRemoved ? 'Add gift back' : 'Remove gift'}"
                  ${isRemoved && !gift.available ? 'disabled' : ''}
                  data-grova-cart-toggle-gift="${gift.variantId}"
                  data-grova-cart-gift-removed="${isRemoved ? 'true' : 'false'}"
                >${isRemoved ? addIcon : removeIcon}</button>
              </div>
            `;
          })
          .join('')}
      </div>
    `;
  }

  function renderEmpty() {
    if (body.querySelector('.grova-cart__empty')) return;
    lastItemsMarkup = null;
    const available = offerConfig.canSyncGifts && offers.canBuy(offerConfig, goldOption);
    const image = root.dataset.emptyGoldImage;
    body.innerHTML = `
      <div class="grova-cart__empty">
        <p class="grova-cart__empty-caption">Your cart is empty.</p>
        <h2 class="grova-cart__empty-heading">Start your daily ritual.</h2>
        ${available ? `<section class="grova-cart__empty-offer" aria-labelledby="grova-empty-offer-title">
          ${image ? `<img class="grova-cart__empty-photo" src="${escapeHtml(image)}" alt="Three pouches of Grova Daily Wellness Mushroom Gummies with a wellness journal and gummy canister" width="938" height="894">` : ''}
          <h3 id="grova-empty-offer-title">Buy 2 bags. Get the 3rd free.</h3>
          <p>3 bags · 90-day supply</p>
          <div class="grova-cart__empty-price">
            ${goldOption.compareAt > goldOption.subscriptionPrice ? `<s>${formatMoney(goldOption.compareAt)}</s>` : ''}
            <strong>${formatMoney(goldOption.subscriptionPrice)}</strong><span>first delivery</span>
          </div>
          <button type="button" class="grova-cart__gold-button" data-grova-empty-add><span>Add Gold Subscription</span> <span aria-hidden="true">·</span> <span>${formatMoney(goldOption.subscriptionPrice)}</span></button>
          <p class="grova-cart__empty-terms">${formatMoney(goldOption.subscriptionPrice)} today, then ${formatMoney(goldOption.renewalPrice)} every 3 months.</p>
          <div class="grova-cart__empty-gifts">
            <span><img src="${escapeHtml(giftImage('journal'))}" alt="" width="32" height="42"><img src="${escapeHtml(giftImage('canister'))}" alt="" width="32" height="42"></span>
            <p>Free journal + canister<br><small>with your first order</small></p>
          </div>
          <ul class="grova-cart__empty-benefits">
            <li>${root.querySelector('[data-grova-empty-shipping]')?.innerHTML || ''}Free shipping</li>
            <li>${root.querySelector('[data-grova-empty-guarantee]')?.innerHTML || ''}30-day first-order money-back guarantee</li>
            <li><img src="${escapeHtml(root.dataset.playPauseIcon || '')}" alt="" width="18" height="18">Adjust or cancel any time</li>
          </ul>
        </section>` : '<p>Find your daily dose of Grova.</p>'}
        <a class="grova-cart__empty-options ${available ? '' : 'grova-cart__empty-button'}" href="${escapeHtml(emptyUrl)}"><span>Explore all purchase options</span>${root.querySelector('[data-grova-empty-arrow]')?.innerHTML || ''}</a>
      </div>`;
  }

  async function addEmptyGold(button) {
    if (updatingLine !== null || !offerConfig.canSyncGifts || !offers.canBuy(offerConfig, goldOption)) return;
    updatingLine = 'empty-add';
    const label = Array.from(button.childNodes);
    const errorMessage = root.querySelector('[data-grova-cart-error]');
    const status = root.querySelector('[data-grova-cart-status]');
    errorMessage.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding Gold…';
    let added = false;
    try {
      // Finish any opening refresh before submitting; never replace another tab's items.
      if (refreshPromise) await refreshPromise;
      await cartRequest('add', { items: offers.items(offerConfig, goldOption) });
      added = true;
      await refreshCart();
      if (status) status.textContent = 'Grova Gold added to your cart.';
      celebrateGold();
    } catch (error) {
      errorMessage.textContent = added ? 'Gold was added. Please reopen your cart to refresh it.' : error.message;
      errorMessage.hidden = false;
    } finally {
      updatingLine = null;
      if (!added) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.replaceChildren(...label);
      }
      if (added && !body.contains(button)) {
        render();
        root.querySelector('.grova-cart__checkout')?.focus({ preventScroll: true });
      }
    }
  }

  function renderPendingAdd() {
    lastItemsMarkup = null;
    root.classList.add('is-pending-add');
    note.hidden = true;
    footer.hidden = true;
    body.innerHTML = `
      <div class="grova-cart__pending" aria-live="polite" aria-busy="true">
        <div class="grova-cart__pending-image"></div>
        <div class="grova-cart__pending-copy">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    `;
  }

  function renderItems() {
    const visibleItems = (cart.items || [])
      .map((item, index) => ({ item, index }))
      .filter(({ item }) => !isSubscriptionGift(item));

    const markup = visibleItems
      .map(({ item, index }) => {
        const original = itemOriginalLinePrice(item);
        const displayedFinal = itemDisplayedLinePrice(item);
        const savings = Math.max(original - displayedFinal, 0);
        const gold = isGoldItem(item);
        const option = subscriptionOptionForItem(item);
        const subscribed = isSubscriptionItem(item);
        const variant = subscribed
          ? option?.key === '1' ? '1 bag delivered monthly' : option?.key === '3' ? '3 bags every 3 months' : `${variantText(item)} · ${deliveryText(item)}`
          : option === monthlyOption ? '1 month supply' : variantText(item);
        const sellingPlan = subscribed ? 'Adjust or cancel any time' : deliveryText(item);
        const playPauseIcon = gold ? root.dataset.playPauseIcon : root.dataset.standardPlayPauseIcon;
        const flexibilityIcon = subscribed && playPauseIcon
          ? `<img class="grova-cart__flexibility-icon" src="${escapeHtml(playPauseIcon)}" alt="" width="18" height="18">` : '';
        const title = option ? 'Grova Mushroom Gummies' : itemTitle(item);
        const image = item.image
          ? `<img class="grova-cart__image" src="${escapeHtml(item.image)}" alt="${escapeHtml(title)}" loading="lazy">`
          : logoMarkup();

        return `
          <article class="grova-cart__item ${gold ? 'grova-cart__item--gold' : ''}" data-line="${index + 1}" data-grova-cart-key="${escapeHtml(item.key)}" aria-busy="${updatingLine !== null}">
            ${gold ? '<div class="grova-cart__card-banner grova-cart__gold-label" data-grova-cart-gold-label tabindex="-1">Buy 2, get 1 free</div>' : ''}
            <a class="grova-cart__image-link" href="${escapeHtml(root.dataset.productReturnUrl || item.url)}">${image}</a>
            <a class="grova-cart__item-title" href="${escapeHtml(root.dataset.productReturnUrl || item.url)}">${escapeHtml(title)}</a>
            <button class="grova-cart__remove" type="button" aria-label="${removingItemKey === item.key ? 'Removing' : 'Remove'} ${escapeHtml(title)}" aria-busy="${removingItemKey === item.key}" data-grova-cart-remove>${removingItemKey === item.key ? '<span class="grova-cart__loading" aria-hidden="true"></span>' : binIcon}</button>
            ${variant ? `<p class="grova-cart__meta grova-cart__variant">${escapeHtml(variant)}</p>` : ''}
            ${sellingPlan ? `<p class="grova-cart__meta grova-cart__selling-plan${subscribed ? ' grova-cart__flexibility' : ''}">${flexibilityIcon}${escapeHtml(sellingPlan)}</p>` : ''}
            <div class="grova-cart__item-controls">
            <div class="grova-cart__quantity" aria-label="Quantity">
              <button type="button" data-grova-cart-quantity="-1" aria-label="Decrease quantity">-</button>
              <span>${item.quantity}</span>
              <button type="button" data-grova-cart-quantity="1" aria-label="Increase quantity">+</button>
            </div>
            <div class="grova-cart__line-price${isSubscriptionItem(item) ? '' : ' grova-cart__line-price--one-time'}">
              ${savings > 0 ? `<s>${formatMoney(original)}</s> ` : ''}
              <span>${formatMoney(displayedFinal)}</span>
              ${savings > 0 ? `<span class="grova-cart__line-saving">Save ${formatMoney(savings)}</span>` : ''}
            </div>
            </div>
            ${bundleGiftMarkup(item)}
            ${isSubscriptionItem(item) || option === monthlyOption ? goldUpgradeMarkup(item, index) : subscriptionControlsMarkup(item, index)}
            ${subscriptionGiftsMarkup(item)}
          </article>
        `;
      })
      .join('');
    if (markup !== lastItemsMarkup) {
      body.innerHTML = markup;
      lastItemsMarkup = markup;
    }
  }

  function syncHeaderCount() {
    document.querySelectorAll('#cart-icon-bubble').forEach((cartLink) => {
      let bubble = cartLink.querySelector('.cart-count-bubble');

      if (!cart.item_count) {
        bubble?.remove();
        return;
      }

      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        cartLink.appendChild(bubble);
      }

      const visibleCount = bubble.querySelector('[aria-hidden="true"]');
      if (visibleCount) visibleCount.textContent = cart.item_count < 100 ? String(cart.item_count) : '';
      const accessibleCount = bubble.querySelector('.visually-hidden');
      if (accessibleCount) accessibleCount.textContent = `${cart.item_count} items`;
    });

    document.querySelectorAll('.cart-bubble__text-count').forEach((el) => {
      el.textContent = cart.item_count ? String(cart.item_count) : '';
      el.classList.toggle('hidden', !cart.item_count);
    });

    document.querySelectorAll('.cart-bubble').forEach((el) => {
      el.classList.toggle('visually-hidden', !cart.item_count);
    });

    document.querySelectorAll('cart-icon').forEach((el) => {
      el.classList.toggle('header-actions__cart-icon--has-cart', Boolean(cart.item_count));
    });

    document.querySelectorAll('[data-instant-dynamic-content-source="CART_COUNT"]').forEach((el) => {
      el.textContent = String(cart.item_count || 0);
      el.hidden = !cart.item_count;
      el.classList.toggle('hidden', !cart.item_count);
      el.classList.toggle('is-hidden', !cart.item_count);
      el.setAttribute('aria-hidden', cart.item_count ? 'false' : 'true');
    });
  }

  function render() {
    const count = cart.item_count || 0;
    const hasGold = (cart.items || []).some(isGoldItem);
    root.classList.toggle('has-gold', hasGold);
    const guarantee = root.querySelector('[data-grova-cart-guarantee]');
    if (guarantee) guarantee.textContent = '30-Day Money-Back Guarantee';
    const checkout = root.querySelector('.grova-cart__checkout');
    if (checkout) {
      checkout.setAttribute('aria-disabled', String(updatingLine !== null));
      checkout.tabIndex = updatingLine !== null ? -1 : 0;
    }
    footer.hidden = !count;
    updateShippingProgress(count);
    renderDiscountCodes();

    if (!count) {
      root.classList.remove('is-pending-add');
      renderEmpty();
    } else {
      root.classList.remove('is-pending-add');
      renderItems();
      const finalTotal = cart.total_price || 0;
      const originalTotal = cart.items.reduce((sum, item) => sum + (isSubscriptionGift(item) ? itemFinalLinePrice(item) : itemOriginalLinePrice(item)), 0);
      const hasSavings = originalTotal > finalTotal;

      totalEl.textContent = formatMoney(finalTotal);
      totalEl.classList.toggle('is-sale', hasSavings);
      if (originalTotalEl) {
        originalTotalEl.hidden = !hasSavings;
        originalTotalEl.textContent = hasSavings ? formatMoney(originalTotal) : '';
      }
      if (checkoutTotalEl) checkoutTotalEl.textContent = formatMoney(finalTotal);
    }

    body.setAttribute('aria-busy', String(updatingLine !== null));
    if (updatingLine !== null) {
      body.querySelectorAll('button').forEach((button) => { button.disabled = true; });
      discountCodesEl?.querySelectorAll('button').forEach((button) => { button.disabled = true; });
    }
    syncHeaderCount();
  }

  function normalizeInstantCartLinks(links = document.querySelectorAll('[data-instant-action-type="add-to-cart"][href]')) {
    links.forEach((link) => {
      const variantId = link.getAttribute('data-instant-action-variant-id');
      if (!variantId) return;

      const url = new URL(link.getAttribute('href'), window.location.origin);
      const currentQuantity = url.pathname.match(/\/cart\/\d+:(\d+)/)?.[1] || '1';
      const normalizedHref = `/cart/${variantId}:${currentQuantity}?storefront=true`;

      if (link.getAttribute('href') !== normalizedHref) {
        link.setAttribute('href', normalizedHref);
      }
    });
  }

  function instantFormForTrigger(trigger) {
    return trigger.closest('[data-instant-form-product-id], form[data-instant-type="root"], [data-instant-type="root"]');
  }

  function parseInstantQuantity(trigger) {
    try {
      const url = new URL(trigger.getAttribute('href') || '', window.location.origin);
      return Number(url.pathname.match(/\/cart\/\d+:(\d+)/)?.[1]) || 1;
    } catch (error) {
      return 1;
    }
  }

  function instantVariantIdForTrigger(trigger) {
    return (
      trigger.getAttribute('data-instant-action-variant-id') ||
      instantFormForTrigger(trigger)?.getAttribute('data-instant-form-variant-id') ||
      ''
    );
  }

  function normalizeSellingPlanId(value) {
    if (!value || value === 'one-time-purchase') return '';
    return value;
  }

  function instantSellingPlanIdForTrigger(trigger) {
    const directPlan = normalizeSellingPlanId(
      trigger.getAttribute('data-instant-action-selling-plan-id') ||
        trigger.getAttribute('data-selling-plan-id') ||
        trigger.getAttribute('selling-plan-id')
    );
    if (directPlan) return directPlan;

    const form = instantFormForTrigger(trigger);
    const activePlan = form?.querySelector(
      '[data-instant-action-type="select-selling-plan"][data-instant-state="active"], [data-instant-action-type="select-selling-plan"][aria-pressed="true"], [data-instant-action-type="select-selling-plan"].is-active'
    );
    const activePlanId = normalizeSellingPlanId(activePlan?.getAttribute('data-instant-selling-plan-id'));
    if (activePlanId || activePlan?.getAttribute('data-instant-selling-plan-id') === 'one-time-purchase') return activePlanId;

    return normalizeSellingPlanId(form?.getAttribute('data-instant-form-selling-plan-id'));
  }

  async function fetchLatestCart() {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      credentials: 'same-origin',
      cache: 'no-store',
    });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }

  function removedSubscriptionGiftVariantIds(cartData) {
    return new Set(
      String(cartData.attributes?.[removedSubscriptionGiftsAttribute] || '')
        .split(',')
        .map((variantId) => variantId.trim())
        .filter(Boolean)
    );
  }

  function desiredSubscriptionGiftQuantities(cartData) {
    return offers.desiredGifts(offerConfig, cartData);
  }

  async function setSubscriptionGiftRemoved(variantId, shouldRemove) {
    const normalizedVariantId = String(variantId);
    const removedVariantIds = removedSubscriptionGiftVariantIds(cart);
    if (shouldRemove) {
      removedVariantIds.add(normalizedVariantId);
    } else {
      removedVariantIds.delete(normalizedVariantId);
    }

    const updates = {};
    if (shouldRemove) {
      (cart.items || []).forEach((item) => {
        if (String(item.variant_id) === normalizedVariantId && isSubscriptionGift(item)) {
          updates[item.key] = 0;
        }
      });
    }

    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates,
        attributes: {
          [removedSubscriptionGiftsAttribute]: [...removedVariantIds].join(','),
          [removedSubscriptionGiftsVersionAttribute]: removedSubscriptionGiftsVersion,
        },
      }),
    });
    if (!response.ok) throw new Error(`Unable to ${shouldRemove ? 'remove' : 'restore'} free gift`);

    cart = await response.json();
    cart = await syncSubscriptionGifts(cart);
    render();
    hydrateAndRender(cart);
  }

  function syncSubscriptionGifts(cartData) {
    if (!offerConfig.canSyncGifts) return Promise.resolve(cartData);
    if (giftSyncPromise) return giftSyncPromise;

    giftSyncPromise = (async () => {
      let nextCart = cartData;
      const removedVariantIds = removedSubscriptionGiftVariantIds(nextCart);
      const removalStateVersion = String(nextCart.attributes?.[removedSubscriptionGiftsVersionAttribute] || '');

      // Older carts can retain gift-removal attributes after every line is removed.
      // Clear that stale state once so a newly added subscription receives its gifts.
      if (removedVariantIds.size && removalStateVersion !== removedSubscriptionGiftsVersion) {
        const resetResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              [removedSubscriptionGiftsAttribute]: '',
              [removedSubscriptionGiftsVersionAttribute]: removedSubscriptionGiftsVersion,
            },
          }),
        });
        if (!resetResponse.ok) throw new Error('Unable to reset free gift preferences');
        nextCart = await resetResponse.json();
      }

      const desiredQuantities = desiredSubscriptionGiftQuantities(nextCart);
      const desiredByVariantId = new Map(
        [...desiredQuantities].map(([key, quantity]) => [String(subscriptionGifts[key].variantId), quantity])
      );
      const existingGiftItems = (nextCart.items || []).filter(isSubscriptionGift);
      const retainedVariantIds = new Set();
      const updates = {};

      existingGiftItems.forEach((item) => {
        const variantId = String(item.variant_id);
        const desiredQuantity = desiredByVariantId.get(variantId) || 0;
        const targetQuantity = desiredQuantity > 0 && !retainedVariantIds.has(variantId) ? desiredQuantity : 0;
        if (targetQuantity > 0) retainedVariantIds.add(variantId);
        if (Number(item.quantity) !== targetQuantity) updates[item.key] = targetQuantity;
      });

      if (Object.keys(updates).length) {
        const updateResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates }),
        });
        if (!updateResponse.ok) throw new Error('Unable to update free gifts');
        nextCart = await updateResponse.json();
      }

      const presentGiftVariantIds = new Set(
        (nextCart.items || []).filter(isSubscriptionGift).map((item) => String(item.variant_id))
      );
      const missingItems = [...desiredQuantities]
        .map(([key, quantity]) => ({ gift: subscriptionGifts[key], quantity }))
        .filter(({ gift }) => gift.available && !presentGiftVariantIds.has(String(gift.variantId)))
        .map(({ gift, quantity }) => ({
          id: gift.variantId,
          quantity,
          properties: {
            _grova_free_gift: 'true',
            _grova_gift_source: 'subscription',
          },
        }));

      if (missingItems.length) {
        const addResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: missingItems }),
        });
        if (!addResponse.ok) throw new Error('Unable to add free gifts');
        nextCart = await fetchLatestCart();
      }

      return nextCart;
    })().finally(() => {
      giftSyncPromise = null;
    });

    return giftSyncPromise;
  }

  function refreshCart() {
    if (refreshPromise) return refreshPromise;

    refreshPromise = (async () => {
      cart = await fetchLatestCart();
      cart = await syncSubscriptionGifts(cart);
      render();
      hydrateAndRender(cart);
      return cart;
    })().finally(() => {
      refreshPromise = null;
    });

    return refreshPromise;
  }

  async function changeLine(itemKey, { remove = false, delta = 0 } = {}) {
    if (updatingLine !== null) return;
    const originalItem = cart.items?.find((item) => item.key === itemKey);
    if (!originalItem) return;
    updatingLine = cart.items.indexOf(originalItem) + 1;
    removingItemKey = remove ? itemKey : null;
    const status = root.querySelector('[data-grova-cart-status]');
    const errorMessage = root.querySelector('[data-grova-cart-error]');
    errorMessage.hidden = true;
    if (status) status.textContent = remove ? 'Removing item…' : 'Updating quantity…';
    render();

    try {
      // Finish pending gift reconciliation before resolving the current item.
      if (refreshPromise) await refreshPromise;
      cart = await fetchLatestCart();
      let item = cart.items.find((entry) => entry.key === itemKey);
      if (!item) {
        // Discounts may change a line key. Only recover an unambiguous matching
        // variant, plan and properties; never fall back to a positional line.
        const properties = (entry) => JSON.stringify(Object.entries(entry.properties || {}).sort(([a], [b]) => a.localeCompare(b)));
        const candidates = cart.items.filter((entry) =>
          String(entry.variant_id) === String(originalItem.variant_id) &&
          String(entry.selling_plan_allocation?.selling_plan?.id || '') === String(originalItem.selling_plan_allocation?.selling_plan?.id || '') &&
          properties(entry) === properties(originalItem));
        if (candidates.length > 1) throw new Error('This item has changed. Your cart has been refreshed. Please try again.');
        if (candidates.length === 1) item = candidates[0];
      }
      if (item) {
        const hadDiscountCodes = appliedCodeDiscounts(cart).length > 0;
        cart = await cartRequest('change', { id: item.key, quantity: remove ? 0 : Math.max(0, item.quantity + delta) });
        if (hadDiscountCodes && appliedCodeDiscounts(cart).length === 0 && cart.item_count > 0) cart = await fetchLatestCart();
      } else if (!remove) {
        throw new Error('This item has changed. Your cart has been refreshed. Please try again.');
      }
      cart = await syncSubscriptionGifts(cart);
      if (status) status.textContent = remove ? 'Item removed from your cart.' : 'Quantity updated.';
      hydrateAndRender(cart);
    } catch (error) {
      try { cart = await fetchLatestCart(); } catch { /* Keep the last confirmed cart. */ }
      if (status) status.textContent = '';
      showCartError(error);
    } finally {
      updatingLine = null;
      removingItemKey = null;
      render();
    }
  }

  async function removeDiscountCode(code) {
    const remainingCodes = appliedCodeDiscounts(cart)
      .map((discount) => discount.title || discount.code)
      .filter((entry) => entry !== code);
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ discount: remainingCodes.join(',') }),
    });

    if (!response.ok) throw new Error('Unable to remove discount code');

    cart = await response.json();
    render();
    hydrateAndRender(cart);
  }

  function showCartError(error) {
    const message = root.querySelector('[data-grova-cart-error]');
    message.textContent = error.message || 'Unable to update your cart. Please try again.';
    message.hidden = false;
  }

  async function cartRequest(endpoint, payload) {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/${endpoint}.js`, {
      method: 'POST', credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Unable to update your cart.');
    return result;
  }

  async function replaceLine(line, option) {
    let item = cart.items?.[line - 1];
    if (updatingLine || !item || !offers.canBuy(offerConfig, option)) return;
    updatingLine = line;
    const upgradingGold = option === goldOption && !isGoldItem(item);
    let upgraded = false;
    const status = root.querySelector('[data-grova-cart-status]');
    if (status) status.textContent = 'Updating your cart…';
    root.querySelector('[data-grova-cart-error]').hidden = true;
    render();

    try {
      const originalKey = item.key;
      cart = await fetchLatestCart();
      item = cart.items.find((entry) => entry.key === originalKey);
      if (!item) throw new Error('This cart item has changed. Please try again.');
      const properties = { ...item.properties };
      if ('_grova_supply_months' in properties) properties._grova_supply_months = option.key;
      properties._grova_purchase_type = 'subscription';
      if (String(item.variant_id) === String(option.variantId)) {
        // Shopify changes the selling plan on the existing line without removing the purchase.
        cart = await cartRequest('change', { line: cart.items.indexOf(item) + 1, quantity: item.quantity,
          properties, selling_plan: option.sellingPlanId });
      } else {
        // Add first. A rejected/out-of-stock replacement leaves the original line intact.
        const added = await cartRequest('add', { items: [{
          id: option.variantId, quantity: item.quantity, properties,
          selling_plan: option.sellingPlanId,
        }] });
        try {
          cart = await cartRequest('change', { id: item.key, quantity: 0 });
        } catch (error) {
          // Restore the added line's previous quantity (it may have merged with an existing line).
          // Do not remove it if the removal response was ambiguous and the old line actually went away.
          const latest = await fetchLatestCart();
          const originalRemains = latest.items.some((entry) => entry.key === item.key);
          const addedKey = added.items?.[0]?.key;
          const addedLine = latest.items.find((entry) => entry.key === addedKey);
          if (originalRemains && addedLine) {
            await cartRequest('change', { id: addedKey, quantity: Math.max(0, addedLine.quantity - item.quantity) });
          }
          if (originalRemains) throw error;
        }
      }
      await refreshCart();
      upgraded = upgradingGold;
      if (status) status.textContent = upgraded ? 'Upgraded to Grova Gold. Your cart and gifts have been updated.' : 'Your cart has been updated.';
    } catch (error) {
      if (status) status.textContent = '';
      try { cart = await fetchLatestCart(); } catch { /* Keep the last confirmed cart. */ }
      showCartError(error);
    } finally {
      updatingLine = null;
      render();
      if (upgraded) {
        root.querySelector('[data-grova-cart-gold-label]')?.focus({ preventScroll: true });
        celebrateGold();
      } else {
        root.querySelector(`[data-line="${line}"] [data-grova-cart-plan], [data-line="${line}"] [data-grova-cart-subscribe]`)?.focus({ preventScroll: true });
      }
    }
  }

  // Existing campaign buttons still use this generic path until their own migration.
  async function addLine({ variantId, quantity, sellingPlanId }) {
    return cartRequest('add', { items: [{ id: Number(variantId), quantity,
      ...(sellingPlanId ? { selling_plan: Number(sellingPlanId) } : {}),
    }] });
  }

  function eventIsInsideCartDrawer(event) {
    return event.target instanceof Element && Boolean(event.target.closest('.grova-cart__drawer'));
  }

  function preventDesktopPageScroll(event) {
    if (!pageScrollLock?.isDesktop || eventIsInsideCartDrawer(event)) return;
    event.preventDefault();
  }

  function preventDesktopPageKeyScroll(event) {
    if (!pageScrollLock?.isDesktop || eventIsInsideCartDrawer(event)) return;
    if (
      event.target instanceof HTMLElement &&
      (event.target.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(event.target.tagName))
    ) {
      return;
    }

    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) {
      event.preventDefault();
    }
  }

  function lockPageScroll() {
    if (pageScrollLock) return;

    if (window.GrovaPageScroll?.mobile()) {
      pageScrollLock = { release: window.GrovaPageScroll.lock(root) };
      document.documentElement.classList.add('grova-cart-open');
      document.body.classList.add('grova-cart-open');
      return;
    }

    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    if (isDesktop) {
      // Do not change html/body styles on desktop. Those layout mutations cause
      // the sticky product carousel to recalculate and visibly jump.
      pageScrollLock = { isDesktop: true };
      document.addEventListener('wheel', preventDesktopPageScroll, { passive: false, capture: true });
      document.addEventListener('touchmove', preventDesktopPageScroll, { passive: false, capture: true });
      document.addEventListener('keydown', preventDesktopPageKeyScroll, true);
      return;
    }

    const doc = document.documentElement;
    const pageBody = document.body;
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    pageScrollLock = {
      isDesktop: false,
      scrollX,
      scrollY,
      docOverflow: doc.style.overflow,
      docOverscrollBehavior: doc.style.overscrollBehavior,
      docScrollBehavior: doc.style.scrollBehavior,
      bodyPosition: pageBody.style.position,
      bodyTop: pageBody.style.top,
      bodyLeft: pageBody.style.left,
      bodyRight: pageBody.style.right,
      bodyWidth: pageBody.style.width,
      bodyOverflow: pageBody.style.overflow,
      bodyOverscrollBehavior: pageBody.style.overscrollBehavior,
    };

    doc.classList.add('grova-cart-open');
    pageBody.classList.add('grova-cart-open');
    doc.style.overflow = 'hidden';
    doc.style.overscrollBehavior = 'none';
    pageBody.style.overflow = 'hidden';
    pageBody.style.overscrollBehavior = 'none';
    pageBody.style.position = 'fixed';
    pageBody.style.top = `-${scrollY}px`;
    pageBody.style.left = `-${scrollX}px`;
    pageBody.style.right = '0';
    pageBody.style.width = '100%';
  }

  function unlockPageScroll() {
    if (!pageScrollLock) return;

    const lock = pageScrollLock;
    pageScrollLock = null;

    if (lock.release) {
      document.documentElement.classList.remove('grova-cart-open');
      document.body.classList.remove('grova-cart-open');
      lock.release();
      return;
    }

    if (lock.isDesktop) {
      document.removeEventListener('wheel', preventDesktopPageScroll, true);
      document.removeEventListener('touchmove', preventDesktopPageScroll, true);
      document.removeEventListener('keydown', preventDesktopPageKeyScroll, true);
      return;
    }

    const doc = document.documentElement;
    const pageBody = document.body;

    doc.classList.remove('grova-cart-open');
    pageBody.classList.remove('grova-cart-open');
    doc.style.overflow = lock.docOverflow;
    doc.style.overscrollBehavior = lock.docOverscrollBehavior;
    doc.style.scrollBehavior = 'auto';
    pageBody.style.position = lock.bodyPosition;
    pageBody.style.top = lock.bodyTop;
    pageBody.style.left = lock.bodyLeft;
    pageBody.style.right = lock.bodyRight;
    pageBody.style.width = lock.bodyWidth;
    pageBody.style.overflow = lock.bodyOverflow;
    pageBody.style.overscrollBehavior = lock.bodyOverscrollBehavior;

    window.scrollTo(lock.scrollX, lock.scrollY);
    requestAnimationFrame(() => {
      doc.style.scrollBehavior = lock.docScrollBehavior;
    });
  }

  function clearGoldConfetti() {
    clearTimeout(confettiTimer);
    root.querySelector('.grova-cart__confetti')?.remove();
  }

  function celebrateGold() {
    clearGoldConfetti();
    if (!root.classList.contains('is-open') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const drawer = root.querySelector('.grova-cart__drawer');
    if (!drawer) return;
    const burst = document.createElement('div');
    burst.className = 'grova-cart__confetti';
    burst.setAttribute('aria-hidden', 'true');
    const colors = ['#c5a754', '#e6d9b4', '#d6bd72', '#b9953e'];
    for (let i = 0; i < 64; i++) {
      const piece = document.createElement('i');
      piece.style.left = `${8 + Math.random() * 84}%`;
      piece.style.backgroundColor = colors[i % colors.length];
      piece.style.setProperty('--confetti-drift', `${(Math.random() - .5) * 110}px`);
      piece.style.setProperty('--confetti-turn', `${(Math.random() - .5) * 720}deg`);
      piece.style.animationDelay = `${Math.random() * 180}ms`;
      burst.appendChild(piece);
    }
    drawer.appendChild(burst);
    confettiTimer = setTimeout(clearGoldConfetti, 2200);
  }

  document.addEventListener('grova:gold-added', celebrateGold);

  // Use the visible viewport, including mobile browser chrome and keyboard changes.
  function syncDrawerViewport() {
    if (!root.classList.contains('is-open')) return;
    const viewport = window.visualViewport;
    const unzoomed = viewport && viewport.scale === 1;
    root.style.setProperty('--grova-cart-viewport-height', `${unzoomed ? viewport.height : window.innerHeight}px`);
    root.style.setProperty('--grova-cart-viewport-top', `${unzoomed ? viewport.offsetTop : 0}px`);
  }
  window.addEventListener('resize', syncDrawerViewport, { passive: true });
  window.visualViewport?.addEventListener('resize', syncDrawerViewport, { passive: true });
  window.visualViewport?.addEventListener('scroll', syncDrawerViewport, { passive: true });

  const cartStyles = document.getElementById('GrovaCartStyles');
  const styleFallback = document.querySelector('[data-grova-cart-style-fallback]');
  let cartOpenRequested = false;
  function cartStylesReady() {
    return !cartStyles || cartStyles.dataset.state === 'loaded';
  }
  function finishCartStyles() {
    if (cartStylesReady()) root.removeAttribute('data-styles-pending');
    if (cartOpenRequested) openCart();
  }
  cartStyles?.addEventListener('load', () => {
    cartStyles.dataset.state = 'loaded';
    cartStyles.media = 'all';
    finishCartStyles();
  });
  cartStyles?.addEventListener('error', () => {
    cartStyles.dataset.state = 'error';
    finishCartStyles();
  });
  document.querySelector('[data-grova-cart-style-dismiss]')?.addEventListener('click', closeCart);
  finishCartStyles();

  function openCart() {
    cartOpenRequested = true;
    if (!cartStylesReady()) {
      if (cartStyles.dataset.state === 'error') {
        if (styleFallback) styleFallback.hidden = false;
      } else {
        cartStyles.media = 'all';
      }
      return;
    }
    clearTimeout(closeTimer);
    lockPageScroll();
    root.classList.remove('is-closing');
    root.classList.add('is-open');
    syncDrawerViewport();
    root.setAttribute('aria-hidden', 'false');
    if (!window.matchMedia('(max-width: 480px)').matches) {
      root.querySelector('.grova-cart__drawer')?.focus({ preventScroll: true });
    }
  }

  // Public hook retained for existing campaign integrations.
  function prepareCartOpen() {}

  function cancelPreparedCartOpen() {
    cartOpenRequested = false;
    if (!root.classList.contains('is-open')) unlockPageScroll();
  }

  function closeCart() {
    cartOpenRequested = false;
    if (styleFallback) styleFallback.hidden = true;
    clearGoldConfetti();
    if (!root.classList.contains('is-open')) return;

    clearTimeout(closeTimer);
    root.classList.remove('is-open');
    root.classList.add('is-closing');
    root.setAttribute('aria-hidden', 'true');
    const timing = getComputedStyle(root).getPropertyValue('--grova-drawer-duration').trim();
    const duration = (parseFloat(timing) * (timing.endsWith('ms') ? 1 : 1000)) || 300;
    closeTimer = setTimeout(() => {
      root.classList.remove('is-closing');
      unlockPageScroll();
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 :
      duration);
  }

  async function refreshAndOpen() {
    // An earlier refresh may have started before the add completed. Fetch again
    // after it settles, then reveal the confirmed cart rather than cached emptiness.
    if (refreshPromise) await refreshPromise;
    const nextCart = await refreshCart();
    openCart();
    return nextCart;
  }

  function renderContents(parsedState) {
    if (!cart.item_count) renderPendingAdd();
    openCart();

    // /cart/add.js returns only added lines, not a complete cart with item_count.
    if (!Array.isArray(parsedState?.items) || typeof parsedState.item_count !== 'number') return refreshCart();

    cart = parsedState;
    render();
    hydrateAndRender(cart);
    return refreshCart();
  }

  root.addEventListener('click', async (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (target.closest('.grova-cart__checkout') && updatingLine !== null) {
      event.preventDefault();
      return;
    }

    if (target.closest('[data-grova-cart-close]')) {
      closeCart();
      return;
    }

    // Do not race gift/discount mutations against an in-flight plan replacement.
    if (updatingLine !== null) return;

    const emptyAdd = target.closest('[data-grova-empty-add]');
    if (emptyAdd) {
      await addEmptyGold(emptyAdd);
      return;
    }

    const removeDiscountButton = target.closest('[data-grova-cart-remove-discount]');
    if (removeDiscountButton) {
      removeDiscountButton.disabled = true;
      removeDiscountCode(removeDiscountButton.dataset.grovaCartRemoveDiscount).catch((error) => {
        removeDiscountButton.disabled = false;
        console.error(error);
      });
      return;
    }

    const toggleGiftButton = target.closest('[data-grova-cart-toggle-gift]');
    if (toggleGiftButton) {
      toggleGiftButton.disabled = true;
      toggleGiftButton.classList.add('is-loading');
      const shouldRemove = toggleGiftButton.dataset.grovaCartGiftRemoved !== 'true';
      setSubscriptionGiftRemoved(toggleGiftButton.dataset.grovaCartToggleGift, shouldRemove).catch((error) => {
        toggleGiftButton.disabled = false;
        toggleGiftButton.classList.remove('is-loading');
        console.error(error);
      });
      return;
    }

    const item = target.closest('[data-line]');
    if (!item || updatingLine) return;

    const line = Number(item.dataset.line);
    const itemKey = item.dataset.grovaCartKey;

    if (target.closest('[data-grova-cart-remove]')) {
      await changeLine(itemKey, { remove: true });
      return;
    }

    const subscribeButton = target.closest('[data-grova-cart-subscribe]');
    if (subscribeButton) {
      const option = subscriptionOptionForItem(cart.items?.[line - 1]);
      replaceLine(line, option);
      return;
    }

    const planButton = target.closest('[data-grova-cart-plan]');
    if (planButton) {
      const option = editableSubscriptionOptions.find((entry) => entry.key === planButton.dataset.grovaCartPlan);
      const currentPlanId = cart.items?.[line - 1]?.selling_plan_allocation?.selling_plan?.id;
      if (String(currentPlanId) === String(option?.sellingPlanId) && String(cart.items?.[line - 1]?.variant_id) === String(option?.variantId)) return;
      replaceLine(line, option);
      return;
    }

    const quantityButton = target.closest('[data-grova-cart-quantity]');
    if (quantityButton) {
      await changeLine(itemKey, { delta: Number(quantityButton.dataset.grovaCartQuantity) });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!root.classList.contains('is-open') && !cartOpenRequested) return;
    if (isOptiMonkEvent(event)) return;
    if (event.key === 'Escape') {
      closeCart();
      return;
    }
    if (!root.classList.contains('is-open')) return;

    if (event.target instanceof Element && event.target.closest('.grova-cart__drawer')) return;
    if (['ArrowDown', 'ArrowUp', 'End', 'Home', 'PageDown', 'PageUp', ' '].includes(event.key)) {
      event.preventDefault();
    }
  });

  document.addEventListener('touchstart', (event) => {
    if (!root.classList.contains('is-open')) return;
    touchStartY = event.touches[0]?.clientY || 0;
  }, { passive: true });

  document.addEventListener('touchmove', (event) => {
    if (!root.classList.contains('is-open')) return;
    if (isOptiMonkEvent(event)) return;
    if (!(event.target instanceof Element)) return;

    const scrollArea = event.target.closest('.grova-cart__body, .grova-cart__footer');
    if (!scrollArea) {
      event.preventDefault();
      return;
    }

    const currentY = event.touches[0]?.clientY || 0;
    const pullingDownAtTop = currentY > touchStartY && scrollArea.scrollTop <= 0;
    const pushingUpAtBottom =
      currentY < touchStartY && scrollArea.scrollTop + scrollArea.clientHeight >= scrollArea.scrollHeight - 1;

    if (pullingDownAtTop || pushingUpAtBottom) event.preventDefault();
  }, { passive: false });

  document.addEventListener('wheel', (event) => {
    if (!root.classList.contains('is-open')) return;
    if (isOptiMonkEvent(event)) return;

    const scrollArea =
      event.target instanceof Element ? event.target.closest('.grova-cart__body, .grova-cart__footer') : null;

    if (!scrollArea) {
      event.preventDefault();
      return;
    }

    const scrollingPastTop = event.deltaY < 0 && scrollArea.scrollTop <= 0;
    const scrollingPastBottom =
      event.deltaY > 0 &&
      scrollArea.scrollTop + scrollArea.clientHeight >= scrollArea.scrollHeight - 1;

    if (scrollingPastTop || scrollingPastBottom) event.preventDefault();
  }, { passive: false });

  document.addEventListener(
    'click',
    (event) => {
      if (!root.classList.contains('is-open')) return;
      if (isOptiMonkEvent(event)) return;
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('.grova-cart__drawer')) return;
      closeCart();
    },
    true
  );

  normalizeInstantCartLinks();

  // Resolve dynamically inserted legacy links only on interaction, not every DOM mutation.
  ['pointerdown', 'focusin', 'contextmenu'].forEach(eventName => {
    document.addEventListener(eventName, event => {
      const link = event.target instanceof Element
        ? event.target.closest('[data-instant-action-type="add-to-cart"][href]') : null;
      if (link) normalizeInstantCartLinks([link]);
    }, true);
  });

  document.addEventListener(
    'click',
    async (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const trigger = target.closest('[data-instant-action-type="add-to-cart"]');
      if (!trigger || root.contains(trigger)) return;

      const variantId = instantVariantIdForTrigger(trigger);
      if (!variantId) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const sellingPlanId = instantSellingPlanIdForTrigger(trigger);
      trigger.setAttribute('aria-busy', 'true');

      try {
        if (!cart.item_count) renderPendingAdd();
        openCart();
        await addLine({
          variantId,
          quantity: parseInstantQuantity(trigger),
          sellingPlanId,
        });
        document.dispatchEvent(
          new CustomEvent('instant:add-to-cart', {
            detail: { variantId, sellingPlanId },
          })
        );
      } catch (error) {
        console.error(error);
      } finally {
        trigger.removeAttribute('aria-busy');
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const trigger = target.closest(
        '[data-grova-cart-trigger], a[href="/cart"], a[href*="/cart"], button[data-testid="cart-drawer-trigger"], [data-instant-action-type*="cart"]'
      );

      if (!trigger || root.contains(trigger)) return;

      const href = trigger.getAttribute('href') || '';
      const actionType = trigger.getAttribute('data-instant-action-type') || '';
      if (actionType === 'add-to-cart') return;

      const isCartTrigger =
        trigger.hasAttribute('data-grova-cart-trigger') ||
        actionType.includes('cart') ||
        href === '/cart' ||
        href.endsWith('/cart') ||
        href.includes('/cart?');

      if (!isCartTrigger) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      refreshAndOpen();
    },
    true
  );

  document.addEventListener('instant:add-to-cart', (event) => {
    event.stopPropagation();
    event.stopImmediatePropagation();
    refreshAndOpen();
  }, true);

  document.addEventListener('submit', async (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form?.matches('.gnp-bundle-grid form, [data-grova-cart-form]')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const formData = new FormData(form);
    const submitButton = form.querySelector('[type="submit"]');
    const originalButtonHtml = submitButton?.innerHTML || 'ADD TO CART';
    const isBundleSaveButton = submitButton?.classList.contains('gbs-add');
    let dotCount = 1;
    const loadingTimer = submitButton && !isBundleSaveButton ? window.setInterval(() => {
      dotCount = dotCount === 3 ? 1 : dotCount + 1;
      submitButton.textContent = `Adding${'.'.repeat(dotCount)}`;
    }, 320) : null;
    if (isBundleSaveButton) {
      submitButton.classList.add('loading');
    } else if (submitButton) {
      submitButton.textContent = 'Adding.';
    }
    submitButton?.setAttribute('aria-busy', 'true');
    if (submitButton) submitButton.disabled = true;

    try {
      await addLine({
        variantId: formData.get('id'),
        quantity: Number(formData.get('quantity') || 1),
      });
      await refreshCart();
      openCart();
    } catch (error) {
      console.error(error);
    } finally {
      if (loadingTimer) window.clearInterval(loadingTimer);
      if (submitButton) {
        submitButton.innerHTML = originalButtonHtml;
        submitButton.classList.remove('loading');
      }
      submitButton?.removeAttribute('aria-busy');
      if (submitButton) submitButton.disabled = false;
    }
  }, true);

  ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxProduct:added', 'ajaxProduct:updated'].forEach((eventName) => {
    document.addEventListener(eventName, refreshCart);
  });

  window.openCartDrawer = refreshAndOpen;
  window.prepareCartDrawerOpen = prepareCartOpen;
  window.cancelPreparedCartDrawerOpen = cancelPreparedCartOpen;
  window.GROVA_CART_DRAWER = {
    open: refreshAndOpen,
    close: closeCart,
    refresh: refreshCart,
    prepare: prepareCartOpen,
    cancelPrepare: cancelPreparedCartOpen,
  };

  root.open = refreshAndOpen;
  root.close = closeCart;
  root.renderContents = renderContents;
  root.getSectionsToRender = () => [{ id: 'cart-icon-bubble' }];
  root.setActiveElement = (element) => {
    root.activeElement = element;
  };

  render();
  hydrateAndRender(cart);
  } catch (error) {
    delete root.dataset.grovaCartInitialized;
    document.documentElement.dataset.grovaCartError = String(error?.message || error);
    console.error('[Grova cart drawer]', error);
  }
})();
